import { forwardRef, type Ref, type SVGProps } from "react";
const IconCollapseFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17 13a2 2 0 0 0 2 2h8a2 2 0 1 0 0-4h-3.172l5.586-5.586a2 2 0 1 0-2.828-2.828L21 8.172V5a2 2 0 1 0-4 0zm-2 6a2 2 0 0 0-2-2H5a2 2 0 1 0 0 4h3.172l-5.586 5.586a2 2 0 1 0 2.828 2.828L11 23.828V27a2 2 0 1 0 4 0z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCollapseFilledSVG);
ForwardRef.displayName = "IconCollapseFilled";
export { ForwardRef as IconCollapseFilled };
